import styled from "styled-components";

export const ToggleFilter = styled.div`
    display: none;

    button {
        width: fit-content;
    }

    @media screen and (max-width: 680px) {
        display: block;
    }
`

export const CloseIcon = styled.img`
    position: absolute;
    top: 10px;
    right: 10px;
    width: 14px;
    height: 14px;
    cursor: pointer;
    display: none;

    @media screen and (max-width: 680px) {
        display: block;
    }
`

export const FilterOptions = styled.div`
    .dropdown {
        margin-right: 12px;
    }
    label {
        height: unset;
    }

    .dropdown-menu {
        padding-right: 4px;

        input[type='checkbox'] {
            top: 2px;
            transform: unset;
        }
        input[type='checkbox'] ~ label {
            &::before {
                top: 2px;
                transform: unset;
            }
            &::after {
                top: 2px;
                transform: unset;
            }
        }
    }

    @media screen and (max-width: 680px) {
        display: block!important;
        position: fixed;
        z-index: 1000;
        background: white;
        width: 300px;
        left: 0px;
        top: 0px;
        bottom: 0px;
        padding: 30px;
        box-shadow: 0px 10px 10px -6px;
        transform: translateX(-100%);
        transition: transform .3s;

        .dropdown-menu {
            position: relative!important;
            transform: unset!important;
        }

        .dropdown {
            padding-top: 8px;
            padding-bottom: 8px;
        }



        &.opened {
            transform: translateX(0px);        
        }
    }
`;

export const List = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 12px 16px;

    .loader {
        grid-column: 1/5;
    }

    @media screen and (max-width: 740px) {
        grid-template-columns: repeat(3, 1fr);


        .loader {
            grid-column: 1/4;
        }
    }

    @media screen and (max-width: 450px) {
        grid-template-columns: repeat(2, 1fr);


        .loader {
            grid-column: 1/3;
        }
    }
`;

export const Item = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;

    .thumbnail-wrapper {
        max-width: 156px;
        width: 100%;
        margin: auto;
    }
    .image-wrapper {
        display: block;
        width: 100%;
        height: 0px;
        padding-top: 100%;
        position: relative;
        border-radius: 50%;
        overflow: hidden;

        img {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    button {
        height: 30px;
        font-size: 14px;
        width: fit-content;
        margin: auto;
        margin-bottom: 0px;
    }
`;

export const EmptyStatus = styled.div`
    grid-column: 1/6;
    text-align: center;
    padding: 45px 16px;
`;